module.exports = __webpack_public_path__ + "img/NOT_EQUAL.e8377b86.svg";